<template>
    <span>

        <div style="width: 99%">
            <v-icon
                class="float-right"
                @click="$emit('close')"
                color="red"
            >
                mdi-close-circle
            </v-icon>
        </div>

        <!-- if entries, display them here here. also, edit and delete buttons for an entry-->
        <span v-if="view == 'select entry'" class="mt-6">
            <v-card-title >{{ $t('your collection entries') }}</v-card-title>

            <!-- list of entries -->
            <div class="scroll-area" v-if="!api_call">
                <template v-for="(item,index) in my_entries">
                    <user-collections-item  :key="item.id" :item="item" :index="index" @clicked="entry=item;view = 'collection entry'" @delete="entry=$event;delete_alert = true" go/>
                </template>
            </div>
            <v-skeleton-loader v-else
               class="mx-auto"
               type="card, article, actions"
            />
            <v-card-actions class="text-right mr-1 mt-1">
                <v-btn class="v-positive-button" @click="view = 'select collection'" small>
                    <v-icon>mdi-playlist-plus</v-icon>
                    {{ $t('create new entry') }}
                </v-btn>
            </v-card-actions>

        </span>

        <!-- select collection view. Depending if add_item is set or not, show different options in selecting a collection -->
        <span v-if="view == 'select collection'" class="mt-6">
            <v-card-title>
                {{ $t('add to list') }}
                <!-- <v-icon>mdi-arrow-down-circle</v-icon> -->
            </v-card-title>

            <!-- the list of collections -->
            <div class="scroll-area" v-if="!api_call">
                <template v-for="(item,index) in my_collections">
                    <user-collections-item :key="item.id" :item="item" :index="index" @clicked="onSelect($event)" go/>
                </template>
            </div>
            <v-skeleton-loader v-else
               class="mx-auto"
               type="card, article, actions"
            />

            <v-card-actions class="ml-2 mt-2 mt-2 mb-2">
                <v-btn class="v-positive-button" @click="$router.push({path: '/collections/new'})" small>
                    <v-icon>mdi-playlist-plus</v-icon>
                    {{ $t('new collection') }}
                </v-btn>
            </v-card-actions>
        </span>

        <!-- list entry view. add new or edit existing entry. depending list type which is selected, chance options -->
        <span v-if="view == 'collection entry'">

            <v-card-title v-if="!date_picker" class="mb-2">{{ $t('provide additional info for collection entry') }}</v-card-title>

            <v-card-text class="scroll-area mt-0 pt-0">

                <v-form>
                    <template v-if="!date_picker">

                        <!-- description (all) -->
                        <v-row dense>
                            <v-col
                                xl="7"
                                lg="7"
                                md="7"
                                sm="7"
                                cols="12"
                                class=""
                            >
                                <v-text-field
                                    :label="$t('comment')"
                                    v-model="entry.description"
                                    background-color="blue-grey darken-3"
                                    class="form-input"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col
                                 xl="3"
                                 lg="3"
                                 md="3"
                                 sm="3"
                                 cols="12"
                                 v-if="entry.description"
                             >
                               <!-- language (all) en,fin -->
                                 <!-- mode (only for new collections) title or release collection. locked if parent -->
                                <v-select
                                    ref="entry_language"
                                    background-color="blue-grey darken-3"
                                    class="form-input small-form"
                                    outlined
                                    dense
                                    :rules="[
                                        (v) => !!v && entry.description != '' || $t('field required'),
                                    ]"
                                    :items="[{
                                        text: $t('english'),
                                        value: 1
                                    },
                                    {
                                        text: $t('finnish'),
                                        value: 5
                                    },
                                ]" v-model="entry.language_id" :label="$t('comment language')" :disabled="entry.description ? false : true">
                                </v-select>
                             </v-col>
                        </v-row>

                        <template v-if="entry.parent.mode == 2">
                            <v-row dense>
                                <v-col
                                    xl="4"
                                    lg="4"
                                    md="4"
                                    sm="4"
                                    cols="8"
                                    class="pt-0"
                                >
                                    <!-- price (releases) -->
                                    <v-text-field :label="$t('price')"
                                          :hint="$t('what did you pay for it')"
                                          background-color="blue-grey darken-3"
                                          class="form-input pt-0"
                                          persistent-hint
                                          max="10000"
                                          min="0"
                                          type="number"
                                          clearable
                                          outlined
                                            dense
                                          v-model="entry.price"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    xl="3"
                                    lg="3"
                                    md="3"
                                    sm="3"
                                    cols="9"
                                    class="pt-0"
                                >

                                    <!-- price currency (release) -->
                                    <v-select
                                        ref="price_currency"
                                        background-color="blue-grey darken-3"
                                        class="form-input small-form"
                                        outlined
                                        dense
                                        :rules="[
                                            (v) => !!v && entry.price != '' || $t('field required'),
                                        ]"
                                              :items="[{
                                            text: $t('EUR'),
                                            value: 'EUR'
                                        },
                                        {
                                            text: $t('GBP'),
                                            value: 'GBP'
                                        },
                                        {
                                            text: $t('USD'),
                                            value: 'USD'
                                        },
                                        {
                                            text: $t('SEK'),
                                            value: 'SEK'
                                        },
                                    ]" v-model="entry.price_currency" :label="$t('currency')" :disabled="entry.price ? false : true">
                                    </v-select>
                                </v-col>
                            </v-row>

                                <!-- condition (release) -->
                                <v-select
                                    background-color="blue-grey darken-3"
                                    class="form-input mt-4 small-form"
                                    outlined
                                    dense
                                    :items="[{
                                        text: $t('new and sealed'),
                                        value: 1
                                    },
                                    {
                                        text: $t('mint'),
                                        value: 2
                                    },
                                    {
                                        text: $t('good'),
                                        value: 3
                                    },
                                    {
                                        text: $t('poor'),
                                        value: 4
                                    },
                                    {
                                        text: $t('worthless'),
                                        value: 5
                                    },
                                ]" v-model="entry.condition" :label="$t('condition')">
                                </v-select>
                        </template>

                        <span v-if="entry.parent.mode == 1">

                            <!-- rating (title) -->
                            <v-select
                                v-if="entry.parent.mode == 1"
                                background-color="blue-grey darken-3"
                                class="form-input small-form pt-0"
                                outlined
                                dense
                                clearable
                                :items="[{
                                    text: '10',
                                        value: 10
                                    },
                                    {
                                        text: '9',
                                        value: 9
                                    },
                                    {
                                        text: '8',
                                        value: 8
                                    },
                                    {
                                        text: '7',
                                        value: 7
                                    },
                                    {
                                        text: '6',
                                        value: 6
                                    },
                                    {
                                        text: '5',
                                        value: 5
                                    },
                                    {
                                        text: '4',
                                        value: 4
                                    },
                                    {
                                        text: '3',
                                        value: 3
                                    },
                                    {
                                        text: '2',
                                        value: 2
                                    },
                                    {
                                        text: '1',
                                        value: 1
                                    }
                                ]"
                                v-model="entry.rating"
                                :label="$t('rating')">
                            </v-select>

                            <!-- source (title) -->
                            <v-select
                                background-color="blue-grey darken-3"
                                class="form-input small-form"
                                outlined
                                dense
                                :items="[{
                                    text: $t('bluray'),
                                    value: $t('bluray')
                                },
                                {
                                    text: $t('uhd'),
                                    value: $t('uhd')
                                },
                                {
                                    text: $t('dvd'),
                                    value: $t('dvd')
                                },
                                {
                                    text: $t('vhs'),
                                    value: $t('vhs')
                                },
                                {
                                    text: $t('cinema'),
                                    value: $t('cinema')
                                },
                                {
                                    text: $t('streaming'),
                                    value: $t('streaming'),
                                },
                                {
                                    text: $t('television'),
                                    value: $t('television')
                                },
                                ]"
                                v-model="entry.source"
                                :label="$t('watched on')">
                            </v-select>

                            <v-row>
                                <v-col
                                    xl="7"
                                    lg="7"
                                    md="7"
                                    sm="7"
                                    cols="12"
                                    >
                                        <v-text-field
                                            background-color="blue-grey darken-3"
                                            :label="$t('watched on custom')"
                                            v-model="entry.source"
                                            outlined
                                            class="form-input"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                        </span>

                        <v-text-field
                            background-color="blue-grey darken-3"
                            class="form-input mt-4 small-form"
                            outlined
                            dense
                            :label="$t('date')"
                            v-model="entry.userdate"
                            @click="!date_picker ? date_picker = true : date_picker = false"
                        ></v-text-field>

                    </template>

                    <!-- userdate (all) picker -->
                    <div v-if="date_picker"
                         class="d-flex justify-center align-center"
                    >
                        <v-date-picker
                            v-model="entry.userdate"
                            @change="date_picker = false"
                            style="max-with:350px"
                            class="ma-auto"
                            :locale="$i18n.locale"
                            first-day-of-week=1
                        ></v-date-picker>
                    </div>
                </v-form>

                <v-alert type="success" center v-if="api_message" class="mb-0">
                    {{ api_message }}
                </v-alert>

                <v-alert type="error" v-if="form_errors" class="mb-0">
                    {{ $t('form errors') }}
                </v-alert>

            </v-card-text>

            <v-card-actions>

                <v-btn text @click="submitEntry" color="green" :disabled="api_call">
                    <span v-if="entry.id">{{ $t('update entry') }}</span>
                    <span v-else>{{ $t('submit new entry') }}</span>
                </v-btn>

                <!-- close -->
                <v-btn text v-if="api_message" @click="$emit('close')" color="primary">
                    <v-icon>mdi-check</v-icon>
                    {{ $t('done') }}
                </v-btn>
                <v-btn v-else text @click="my_entries.length > 0 ? view = 'select entry' : view = 'select collection'">
                    {{ $t('cancel') }}
                </v-btn>

                <template v-if="entry.id">
                    <v-spacer></v-spacer>
                    <v-btn text color="red" @click.stop="delete_alert = true">
                        <v-icon>mdi-delete-forever</v-icon>
                        {{ $t('delete') }}
                    </v-btn>
                </template>

            </v-card-actions>

        </span>

        <v-dialog
            v-model="delete_alert"
            max-width="400"
        >
            <v-alert
                prominent
                type="error"
            >
                <v-row>
                    <v-col align="center">
                        {{ $t('confirm delete') }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col align="right">
                        <v-btn class="warning" @click="deleteEntry()">{{ $t('delete') }}</v-btn>
                    </v-col>
                    <v-col align="left">
                        <v-btn class="warning" @click="delete_alert = false">{{ $t('cancel') }}</v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </v-dialog>
    </span>
</template>

<script>

//add and edit collection entries
//add and edit collections
import imageMethods from '../mixins/imageMethods'
import AppMixins from "@/mixins/app";
import UserCollectionsItem from "./UserCollectionsItem.vue";

export default {
    name: "UserCollections",
    props: ["add_item", "ts"],
    mixins: [imageMethods, AppMixins],
    components: {
        UserCollectionsItem
    },
    data: function () {
        return {
            view: "select collection",
            delete_alert: false,
            delete_collection: false,
            my_collections: [],
            my_entries: [],
            entries: false, //used when selecting entry picture
            add_collection: [],
            entry: {},
            collection: {},
            api_message: null,
            form_errors: null,
            date_picker: false,
        }
    },
    watch: {

        '$route'() {

            //only redo search if query differs between to and from
            this.$emit('close')

        },

        ts(){
            this.date_picker = false
            this.my_collections = []
            this.my_entries = []
            this.api_message = null
            this.form_errors = null
            this.view = 'select collection'
                //determine which view
            if(this.ts) {
                if (this.add_item && this.add_item.list_entries_count_auth) {
                    this.view = 'select entry'
                    this.getEntries()
                }

                this.resourceHandler('my_collections', this.model2mode())
            }
        },

        view(){
            if(this.view == 'collection entry'){
                if(this.entry.price) this.entry.price = this.entry.price / 100
                this.date_picker = false
            }
        }
    },
    methods: {

        getCollectionEntries(){

            this.resourceHandler('entries', '?list_model_id='+this.collection.id+'&&skip=0&take=30&with_listable=1&sort=updatedDesc')

        },

        //submit this.collection to api
        //Send global new owned add. Send local list_entries_count_auth add. If parent list is default send local owned_count_auth: true.
        submitEntry(){
            this.api_message = null
            if(this.entry.description &&  this.entry.description != '' && !this.entry.language_id) {
                this.form_errors = true
                this.$refs['entry_language'].validate(true)
                return
            }

            if(this.entry.price &&  this.entry.price != '' && !this.entry.price_currency) {
                this.form_errors = true
                this.$refs['price_currency'].validate(true)
                return
            }

            if(this.api_call) return //prevent multiple submit
            this.api_call = true //lock for calls

            this.form_errors = false


            //determine which api verb to use with collections resource PUT will access update route, POST store new
            var verb = 'post'
            var url = 'entries'
            if(this.entry.id){
                url = 'entries/'+this.entry.id
                verb = 'put'
            }

            //api call
            this.axios[verb](url, this.entry)
                .then(response => {

                    this.api_call = false

                    if(verb == 'post') {
                        this.api_message = this.$t('new entry created') //todo price
                        if(this.entry.parent?.mode == 2 && this.entry.price > 0 && this.entry.price_currency) this.api_message += '. '+this.$t('thanks for price')
                        this.my_entries.unshift(response.data)
                        this.entry.id = response.data

                        //on new release entry
                        //Send local list_entries_count_auth add. If parent list is default send local owned_count_auth: true.
                        if(this.entry.parent.default) {

                            if(this.entry.parent.mode == 1 && this.entry.parent.style == 2)
                                this.$root.$emit('videospace', {
                                    model: 'title',
                                    model_id: this.add_item.id,
                                    data: {
                                        seen_count_auth: 'add',
                                        list_entries_count_auth: "add",
                                    }
                                })

                            if(this.entry.parent.mode == 1 && this.entry.parent.style == 6)
                                this.$root.$emit('videospace', {
                                    model: 'title',
                                    model_id: this.add_item.id,
                                    data: {
                                        want_see_count_auth: 'add',
                                        list_entries_count_auth: "add",
                                    }
                                })

                            if(this.entry.parent.mode == 2 && this.entry.parent.style == 3)
                                this.$root.$emit('videospace', {
                                    model: 'release',
                                    model_id: this.add_item.id,
                                    data: {
                                        owned_count_auth: 'add',
                                        list_entries_count_auth: "add",
                                    }
                                })

                            if(this.entry.parent.mode == 2 && this.entry.parent.style == 4)
                                this.$root.$emit('videospace', {
                                    model: 'release',
                                    model_id: this.add_item.id,
                                    data: {
                                        wanted_count_auth: 'add',
                                        list_entries_count_auth: "add",
                                    }
                                })

                        }else
                            this.$root.$emit('videospace', {
                                model: this.add_item.model,
                                model_id: this.add_item.id,
                                action: 'list_entries_count_auth',
                                data: {
                                    list_entries_count_auth: "add",
                                }
                            })

                        this.$gtag.event('new_collection_entry', {
                            'model': this.add_item.model,
                            'model_id': this.add_item.id,
                            'videospace_user_id': this.$store.state.auth_user.id,
                        })

                    }else {

                        this.api_message = this.$t('updated') //todo price
                        console.log(this.entry)
                        if(this.entry.parent?.mode == 2 && this.entry.price > 0 && this.entry.price_currency) this.api_message += '. '+this.$t('thanks for price')
                        this.my_entries.splice(this.my_entries.findIndex(x => x.id == response.data.id), 1);
                        this.my_entries.unshift(this.entry)
                    }

                    //reload collections because there could be an update to the list pictures UNDONE


                })
                .catch(e => {
                    if(e.response) this.form_errors = e.response.status
                    this.api_call = false
                })

        },


        model2mode(){
            if(this.add_item)
                switch(this.add_item.model) {
                    case "Release": return '?mode=2'
                    case "Title": return '?mode=1'
                    case "release": return '?mode=2'
                    case "title": return '?mode=1'

                }
        },

        //determine which view to display when select collection
        onSelect(item){

            this.api_message = null
            this.api_call = false
            this.form_errors = null

            //crerate fresh entry
            this.entry = {
                listable_id: this.add_item.id,
                listable_type: this.add_item.model.toLowerCase() == 'release' ? 'App\\Release' : 'App\\Title',
                listable_item: this.add_item,
                parent: item,
            }

            if(this.add_item){
                this.view = 'collection entry'
            }
            else {
                this.view = 'collection'
            }

        },

        getEntries(){
            this.axios.get('my_list_entries?model='+this.add_item.model+'&model_id='+this.add_item.id+'&with_parent=1').then(response => {this.my_entries = response.data})
        },

        //delete entry. Send global new owned sub. Send local list_entries_count_auth sub. If parent list is default send local owned_count_auth: false.
        deleteEntry(){

            this.axios.delete('/entries/'+this.entry.id, {

            }).then(() => {
                //remove from local list
                this.my_entries.splice(this.my_entries.findIndex(x => x.id == this.entry.id), 1);

                //close alert
                this.delete_alert = false

                //If parent list is default send local owned_count_auth: false. Send local list_entries_count_auth sub
                if(this.entry.parent.default && this.entry.parent.style == 2) //have seen
                    this.$root.$emit('videospace', {
                        model: this.add_item.model,
                        model_id: this.add_item.id,
                        data: {
                            list_entries_count_auth: "sub",
                            seen_count_auth: "sub",
                        }
                    })
                else if(this.entry.parent.default && this.entry.parent.style == 3) //own it
                    this.$root.$emit('videospace', {
                        model: this.add_item.model,
                        model_id: this.add_item.id,
                        data: {
                            list_entries_count_auth: "sub",
                            owned_count_auth: "sub",
                        }
                    })
                else if(this.entry.parent.default && this.entry.parent.style == 4) //want it
                    this.$root.$emit('videospace', {
                        model: this.add_item.model,
                        model_id: this.add_item.id,
                        data: {
                            list_entries_count_auth: "sub",
                            wanted_count_auth: "sub",
                        }
                    })
                else if(this.entry.parent.default && this.entry.parent.style == 6) //want see
                    this.$root.$emit('videospace', {
                        model: this.add_item.model,
                        model_id: this.add_item.id,
                        data: {
                            list_entries_count_auth: "sub",
                            want_see_count_auth: "sub",
                        }
                    })
                else
                    //Else only send local list_entries_count_auth sub
                    this.$root.$emit('videospace', {
                        model: this.add_item.model,
                        model_id: this.add_item.id,
                        action: 'delete_list_entries_count_auth',
                        data: {
                            list_entries_count_auth: "sub",
                        }
                    })

                //change view if no other entries in my_entries
                if(this.my_entries.length == 0)
                    this.$emit('close')
                    else
                    this.view = 'select entry'

            })
        },

        deleteCollection(){

            this.axios.delete('/collections/'+this.collection.id, {

            }).then(() => {
                //remove from local list
                this.my_collections.splice(this.my_collections.findIndex(x => x.id == this.collection.id), 1);

                //close alert
                this.delete_collection = false

                //go to collection view
                this.view = 'select collection'
            })
        }
    },
    computed: {

        //UserCollections can have 3 modes:
        //1. edit collections
        //2. new entry
        //3. edit entry
        mode(){

            if(this.add_item && this.add_item.list_entries_count_auth) return 3
            if(this.add_item) return 2
            return 1

        },

    },
    created() {

        //determine which view
        if(this.add_item && this.add_item.list_entries_count_auth){
            this.view = 'select entry'
            this.getEntries()
        }

        this.resourceHandler('my_collections', this.model2mode())
    }
}
</script>

<style scoped>
.scroll-area{
    max-height: 380px;
    min-height: 380px;
    overflow-y: auto; /* Use 'auto' instead of 'hidden' to enable vertical scroll when needed */
    overflow-x: hidden; /* Hide horizontal scroll */
}
.small-form{
    width: 200px;
}

@media(max-width: 767px) {
    .scroll-area {

    }
}

</style>
